import { send } from '../../../../src/network/network';
import {
  type PaginatedProductList,
  type PaginatedProductListWithSideloadedTags,
} from '../../../../src/types/PaginatedProductList';
import { type Product } from '../../../../src/types/Product';
import { convertTagIdsToTags } from '../../../../src/utils/convertTagIdsToTags';
export { type Product as ProductV2 } from '../../../../src/types/Product';

export { type PaginatedProductList };

export async function getProductsRequest(params: URLSearchParams) {
  /**
   * The below is a query string hack to allow customers to filter `Organic` on the `Produce` tab. (WEB-5392)
   *
   * It's not ideal, but BE requested that clients take on this tech debt until they can refactor those endpoints
   * more holistically.
   */
  const certificationTags = params.getAll('certification_tags');
  const isFilteringProduce = params.get('categories') === '1'; // category 1 is produce
  const isFilteringOrganicCertificationTag =
    certificationTags.length > 0 && certificationTags.includes('15'); // certification tag 15 is `organic`
  if (isFilteringProduce && isFilteringOrganicCertificationTag) {
    params.append('certification_tags', '814'); // certification tag 814 is `organic produce`
  }

  params.set('sideload', 'tags');

  const resp = await send<PaginatedProductListWithSideloadedTags>({
    method: 'GET',
    path: '/api/v2/products/',
    query: params,
  });

  if (resp.data?.results?.products?.length === 0) {
    const data: PaginatedProductList = {
      ...resp.data,
      results: [],
    };

    return {
      status: resp.status,
      data,
    };
  }

  const tags = resp.data.results.tags;

  const mappedProducts: Product[] = resp.data.results.products.map(
    (product) => {
      return {
        ...product,
        tags: convertTagIdsToTags(product.tags, tags),
      };
    }
  );

  const data: PaginatedProductList = {
    ...resp.data,
    results: mappedProducts,
  };

  return {
    status: resp.status,
    data,
  };
}
